import React from 'react';
import { Box } from 'grommet';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
const LinearLayout = ({
  children
}) => {
  const {
    pathname
  } = useLocation();
  return /*#__PURE__*/React.createElement(Box, {
    fill: true
  }, (pathname === '/' || pathname === '/terms' || pathname === '/privacy-policy') && /*#__PURE__*/React.createElement(Header, null), children, (pathname === '/' || pathname === '/terms' || pathname === '/privacy-policy') && /*#__PURE__*/React.createElement(Footer, null));
};
export default LinearLayout;